import React from 'react';
import { message, Radio, Modal, Input } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;
let session = {};
let searchParams = {};

class RegisterRequest extends React.Component {
    state = {
        flag: '',
        reason: undefined,
        loading: false,
        visible: false,
    }

    show = (setSession, params) => {
        session = setSession;
        searchParams = params;
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({
            flag: '',
            visible: false,
        });
    }


    confirmNoticeReadByOne = (noticeId) => {
        const options = {
            method: 'POST',
            url: API_URL.home.confirmNoticeReadByOne,
            data: { noticeId },
            dataType: 'json',
            doneResult: () => {
                this.props.loadData();
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { flag, reason } = this.state;
        if (!flag) {
            message.warning('请选择是否现在前往登记请款记录!');
            return;
        }
        if (flag === 1) {
            this.hide();
            this.props.autoRegisterRequest(session, searchParams);
        } else if (flag === 2) {
            this.hide();
        } else {
            if (!reason) {
                message.warning('请输入取消原因！');
                return;
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.notice.applyCancelNotice,
                data: {
                    reason,
                    relatedId: searchParams.investigationJdeContractId,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.hide();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        }
    }

    handleChange = (value, key) => {
        const state = this.state;
        switch (key) {
            case 'flag':
                state.reason = undefined;
            default:
                state[key] = value;
        }
        this.setState(state);
    }

    render() {
        const { flag, loading, visible, reason } = this.state;
        const radioStyle = {
            display: 'block',
            height: '24px',
            lineHeight: '24px',
        };

        return (
            <Modal
                title="合同请款记录登记通知"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ paddingLeft: 10, lineHeight: '32px', background: '#FAFAFA' }}>是否现在前往登记请款记录?</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ marginLeft: 24 }}>
                                <RadioGroup value={flag} onChange={e => this.handleChange(e.target.value, 'flag')}>
                                    <Radio value={1} style={radioStyle}>是，立刻为此合同登记请款记录</Radio>
                                    <Radio value={2} style={radioStyle}>否，稍后自行前往登记</Radio>
                                    <Radio value={3} style={radioStyle}>否，申请取消提醒</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {
                            flag == 3 &&
                            <li className="modal-item">
                                <div className="item-left" style={{ marginLeft: 45, marginTop: 10 }}>
                                    <Input placeholder="请输入" value={reason} onChange={e => this.handleChange(e.target.value, 'reason')} />
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default RegisterRequest;



// WEBPACK FOOTER //
// ./src/components/layout/notice/RegisterRequest.js